export default "__VITE_ASSET__67ceb834__"